import { ApiService } from '../services/api.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

export async function openModuleLink({
  code,
  title,
  router,
  apiService
}: {
  code: string;
  title: string;
  router: Router;
  apiService: ApiService;
}): Promise<void> {
  try {
    const moduleDetailResponse = await firstValueFrom(apiService.getModuleDetails(code));
    const response = moduleDetailResponse?.response;
    if (response?.IsMaintenance) {
      router.navigate(['/under-construction'], {
        state: {
          data: {
            moduleName: title
          }
        }
      });
      return;
    }
    // Does not work on local because ModuleAddress from dev server API will not use localhost
    const moduleAddress = response?.ModuleAddress ?? '';
    const currentDomain = window.location.host;
    if (moduleAddress.startsWith(currentDomain)) {
      const path = moduleAddress.replace(currentDomain, '');
      router.navigate([path]);
    } else {
      window.open(`//${moduleAddress}`, '_blank');
    }
  } catch (error) {
    // Handle error if needed
  }
}
